class WorkFlowField {
  constructor(props) {
    const {
      attribute_code = '',
      compare_param_options = [],
      crm_data_type = '',
      display_name = '',
      picklists = [],
    } = props;

    this.id = attribute_code;
    this.field_label = display_name;
    this.dataType = crm_data_type;
    this.picklists = picklists;
    this.compareOptions = compare_param_options;
  }
}

export default WorkFlowField;



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/models/WorkFlowField.js